import React from "react";
import styled from "styled-components";
import profileImage from "../img/profile_pic.png";
import { FaEnvelope, FaPhone, FaLinkedin } from "react-icons/fa6";
import { FaMapMarkerAlt } from "react-icons/fa";

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: left;
  margin-left: 80px;
  margin-bottom: 20px;
  width: 100%;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    text-align: center;
    margin-left: 0px;
  }

  @media print {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

const ProfileImage = styled.img`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  border: 1.7px dashed #000;
  object-fit: cover;
  margin-right: 50px;

  @media screen and (max-width: 991px) {
    margin-bottom: 10px;
    margin-right: 0px;
  }

  @media print {
    margin-right: 60px;
    margin-bottom: 0px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Name = styled.h1`
  font-size: 2.2rem;
  font-weight: normal;
  font-variant: small-caps;
  color: #538135;
  margin-top: 0px;
  margin-bottom: 0px;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: normal;
  font-variant: small-caps;
  margin-top: 0px;
  margin-bottom: 30px;
`;

const ContactsWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto; /* shrink to content */
  column-gap: 32px; /* space between columns */
  row-gap: 8px;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    column-gap: 0;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.95rem;
`;

const ContactLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Profile = ({ name, position, contactInfo }) => {
  return (
    <ProfileContainer>
      <ProfileImage src={profileImage} alt="Profile Picture" />
      <TextContainer>
        <Name>{name}</Name>
        <Title>{position}</Title>

        <ContactsWrapper>
          {/* First Column */}
          <Column>
            {contactInfo?.location && (
              <ContactItem>
                <FaMapMarkerAlt />
                <span>{contactInfo.location}</span>
              </ContactItem>
            )}
            {contactInfo?.phone && (
              <ContactItem>
                <FaPhone />
                <span>{contactInfo.phone}</span>
              </ContactItem>
            )}
          </Column>

          {/* Second Column */}
          <Column>
            {contactInfo?.linkedin && (
              <ContactItem>
                <FaLinkedin />
                <ContactLink
                  href={contactInfo.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  linkedin.com/in/anna-schmeier
                </ContactLink>
              </ContactItem>
            )}
            {contactInfo?.email && (
              <ContactItem>
                <FaEnvelope />
                <ContactLink href={`mailto:${contactInfo.email}`}>
                  {contactInfo.email}
                </ContactLink>
              </ContactItem>
            )}
          </Column>
        </ContactsWrapper>
      </TextContainer>
    </ProfileContainer>
  );
};

export default Profile;
